import classnames from 'classnames';

import { SanityImage } from '@components/SanityImage';

import { CmsShowcaseGridItem } from '@interfaces/common';

import styles from './ProductShowcaseItem.module.css';

interface ProductShowcaseItemProps
	extends Omit<CmsShowcaseGridItem, '_key' | 'sellSheet'> {
	imageSizes: string;
	url: string;
	linkText: string;
}

export const ProductShowcaseItem: React.VFC<ProductShowcaseItemProps> = ({
	image,
	imageSizes,
	title,
	description,
	url,
	linkText,
}) => {
	return (
		<article className={styles.wrapper}>
			<SanityImage className={styles.image} image={image} sizes={imageSizes} />
			<h3 className="fluid-font-t5-bold">{title}</h3>
			<p className={classnames(styles.description, 'fluid-font-t6-bold')}>
				{description}
			</p>
			<a
				className="fluid-font-t6-bold"
				download
				href={url}
				rel="noreferrer noopener"
				target="_blank"
			>
				{linkText}
			</a>
		</article>
	);
};
